export default "__VITE_ASSET__CtKKhjEw__"